import { Box, Heading, Image, Paragraph } from '@zillow/constellation-10';
import zillowAndPlaidSvg from '@assets/zillow-plaid.svg';

export const VerificationInProgress = () => {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'token(spacing.md)' }}>
      <Image alt="zillow-plaid" css={{ width: '100px' }} src={zillowAndPlaidSvg as unknown as string} />
      <Heading level={2} textStyle="heading-xs">
        Verification in progress
      </Heading>
      <Paragraph>
        Your account will be automatically verified by Plaid in approximately one day. No action is needed on your part.
      </Paragraph>
    </Box>
  );
};
